/**
 * The bar width the walkthrough replay is watched at, in px — the user's, and only theirs.
 *
 * One value for every strategy and timeframe, on this device. A bar width is a reading
 * preference ("how big do I want a candle to be"), not a fact about any one chart, which is why
 * it is stored in pixels rather than as bars-per-screen: the same comfortable candle on H4 and
 * on M5, on a wide monitor and a narrow one.
 *
 * Written only when the user zooms the replay (BacktestChart's onBarSpaceChange, which only
 * fires for gestures). Until then there is nothing here, and each walkthrough opens at its own
 * canvas's zoom — see WorkbenchWalkthrough.
 *
 * localStorage, not the server: a per-viewer convenience that is harmless to lose, and the same
 * class of preference as the chat's model selection (chatSelection).
 */

const KEY = 'algobuilder.walkthroughBarSpace'

/** klinecharts' own limits — BarSpaceLimitConstants. setBarSpace ignores anything outside. */
const MIN_BAR_SPACE = 1
const MAX_BAR_SPACE = 50

function valid(value: unknown): value is number {
  return typeof value === 'number' && Number.isFinite(value)
    && value >= MIN_BAR_SPACE && value <= MAX_BAR_SPACE
}

export const replayZoom = {
  get(): number | null {
    try {
      const raw = localStorage.getItem(KEY)
      const value = raw == null ? null : Number(raw)
      return valid(value) ? value : null
    } catch {
      return null
    }
  },

  set(barSpace: number): void {
    if (!valid(barSpace)) return
    try {
      localStorage.setItem(KEY, String(barSpace))
    } catch {
      // storage unavailable — the zoom just won't survive this walkthrough
    }
  },
}
